import { render, staticRenderFns } from "./HeaderWx.vue?vue&type=template&id=eec3d440&scoped=true&"
import script from "./HeaderWx.vue?vue&type=script&lang=js&"
export * from "./HeaderWx.vue?vue&type=script&lang=js&"
import style0 from "./HeaderWx.vue?vue&type=style&index=0&id=eec3d440&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec3d440",
  null
  
)

export default component.exports